import React from 'react';
import { useReadNotification } from '../../shared/mutations/readNotification';

const ToggleViewNotification = ({ render }) => {
  const { read, isLoading: isReadLoading } = useReadNotification();
  return render({ read, isReadLoading });
};

export default ToggleViewNotification;
